module.exports = __webpack_public_path__ + "img/dentist_thumbnail-600x450.1f0c620a.jpg";